/* sgb004 */ 

(() => {
	class FormSearhWidget{
		constructor(){
			this.addEventListeners();
		}
		
		addEventListeners(){
			const forms = document.querySelectorAll('.form-search-widget');
			
			for( const form of forms ){
				if( form instanceof HTMLFormElement ){
					form.addEventListener('submit', this.handleSubmit.bind(this), true);
					this.addEventListenerSubmitButton(form);
				}
			}

		}

		addEventListenerSubmitButton(form){
			const buttons = form.querySelectorAll('input[type="submit"], button[type="submit"]');

			for(let button of buttons){
				button.addEventListener('click', this.handleSubmit.bind(this));
			}
		}

		cleanFilters(filters){
			const result = {};
			
			for( const filter in filters ){
				if( filters[filter] !== '' ){
					const value = `${filters[filter]}`.toLowerCase();
					result[filter] = [value];
				}
			}
			
			return result;
		}

		getUrl(form){
			const formData = new FormData(form)
			const formAction = form.action.split('?')[0];
			const data = Object.fromEntries(formData.entries());
			const filters = this.cleanFilters(data);
			const url = `${formAction}?filters=${encodeURIComponent(JSON.stringify(filters))}`;

			return url;
		}
		
		handleSubmit(event){
			event.stopPropagation();
			event.preventDefault();
			event.stopImmediatePropagation();

			const element = event.target instanceof HTMLFormElement ? event.target : event.target.form;
			const url = this.getUrl(element);
			
			location.href = url;
		}
	}
	
	function handleReady(){
		new FormSearhWidget();
	}
	
	document.addEventListener('DOMContentLoaded', handleReady);
})();